module.exports = __webpack_public_path__ + "static/media/roundbox1.29d5a78e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pretty_Lashed/gp/roundbox1.JPG
// module id = 458
// module chunks = 0